// extracted by mini-css-extract-plugin
export default {"container":"CopyBlock_container__PaBNX","button":"CopyBlock_button__k-dhS","message":"CopyBlock_message__TTSTb","showMessage":"CopyBlock_showMessage__9dWuc"};